(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cust_faq-with-image"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valentine-custom-section"] && !window.DesignMode) return;
  try {
    
  function handleBlockClick() {
    let link = document.querySelectorAll('[data-link]');
    link.forEach(function(link){
      link.addEventListener('click', function(e){
        e.stopPropagation();
        window.location.href = link.getAttribute('data-link');
      });
    });
  }
  function alignPrimeTitle(){
    document.querySelectorAll('.valentine-lp-section').forEach(function(element){
      var titleHeight = 0;
      element.style.setProperty('--title-height', 'auto');
      element.querySelectorAll('.prime-day-block-content-title').forEach(function(titleElem){
        if(titleElem.clientHeight > titleHeight) titleHeight = titleElem.clientHeight;
      });
      element.style.setProperty('--title-height', titleHeight + 'px');
    });
  }
  function initializeTooltipEvents() {
    if(document.querySelectorAll('[data-tooltip]').length > 0){
      document.querySelectorAll('[data-tooltip]').forEach(function(tooltip){
        if(window.innerWidth < 750){
          tooltip.addEventListener('click', function(e){
            e.stopPropagation(); // Prevent the event from bubbling up
            this.querySelector('.product_info').classList.add('active');
          })
        }
        else{
          tooltip.addEventListener('mouseover', function(e){
            this.querySelector('.product_info').classList.add('active');
          });
          tooltip.addEventListener('mouseout', function(e){
            this.querySelector('.product_info').classList.remove('active');
          });
        }

        tooltip.querySelector('.info-close').addEventListener('click', function(e){
          this.closest('.product_info').classList.remove('active');
        });
      });

      document.addEventListener('click', function(e){
        var el = e.target;
        if(!el.classList.contains('valentine_product-info-svg') && !el.closest('.valentine_product-info-svg')){
          if(document.querySelector('.product_info.active')) document.querySelector('.product_info.active').classList.remove('active');
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    alignPrimeTitle();
    initializeTooltipEvents();
    handleBlockClick();

    window.addEventListener('resize', function(){
      setTimeout(function(){
        alignPrimeTitle();
        initializeTooltipEvents();
      }, 500);
    });

  });

  } catch(e) { console.error(e); }
})();
})();
